import { baseURL } from "utils/WebService";

/**
 * Backend fora do ar (pedido da Aline em 26/10/2026). Quando uma chamada fica sem resposta (o IIS responde 502/503/504
 * porque o backend parou, ou não há conexão), a tela confere o backend em /no-ar. Se ele não responder, o aviso
 * "Sistema em manutenção" (components/ServidorFora) aparece por cima de tudo, confere de novo de tempos em tempos e fecha
 * sozinho quando o backend volta; o que estava aberto continua na tela. Sem resposta também do servidor do próprio front
 * (/version.json, servido pelo IIS), o problema é a rede de quem usa: "Sem conexão".
 *
 * Estados: "ok", "manutencao" e "semConexao".
 */
const LIMITE_MS = 10000;
let estado = "ok";
let conferindo = null;
const ouvintes = new Set();

/** Resposta do proxy sem o backend atrás (ou que não respondeu a tempo). */
export function respostaDeServidorFora(status) {
  return status === 502 || status === 503 || status === 504;
}

export function estadoDoServidor() {
  return estado;
}

/** Avisa a cada mudança de estado (e já com o estado atual). Devolve a função que para de ouvir. */
export function ouvirServidor(ouvinte) {
  ouvintes.add(ouvinte);
  ouvinte(estado);
  return () => ouvintes.delete(ouvinte);
}

/** Confere se o backend responde (uma conferência por vez; quem chama durante uma recebe a mesma). */
export function conferirServidor() {
  if (!conferindo) {
    conferindo = sondar()
      .then((novo) => {
        if (novo !== estado) {
          estado = novo;
          ouvintes.forEach((ouvinte) => ouvinte(estado));
        }
        return estado;
      })
      .finally(() => {
        conferindo = null;
      });
  }
  return conferindo;
}

async function responde(url) {
  const controle = new AbortController();
  const tempo = setTimeout(() => controle.abort(), LIMITE_MS);
  try {
    const resposta = await fetch(url, { cache: "no-store", signal: controle.signal });
    return !respostaDeServidorFora(resposta.status);
  } catch (e) {
    return false;
  } finally {
    clearTimeout(tempo);
  }
}

async function sondar() {
  // Qualquer resposta que não seja do proxy conta como no ar (até o 403 de um backend antigo, sem o /no-ar)
  if (await responde(`${baseURL}/no-ar?_t=${Date.now()}`)) return "ok";
  return (await responde(`/version.json?_t=${Date.now()}`)) ? "manutencao" : "semConexao";
}
